var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 81,
    viewBox: "0 0 100 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_13089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4531 22.1617H66.5046L75.1981 13.4682L75.6256 9.7796C59.4501 -4.49715 34.7571 -2.95881 20.4804 13.2167C16.5109 17.7102 13.6312 23.0545 12.0635 28.839C13.0318 28.4408 14.1049 28.3779 15.1151 28.6546L32.4978 25.7875C32.4978 25.7875 33.3822 24.3246 33.8391 24.4168C41.5727 15.9245 54.5878 14.9353 63.516 22.1617H63.4531Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5801 28.839C85.5807 21.4827 81.4813 14.8682 75.7765 9.80893L63.5788 22.0066C68.7303 26.215 71.6645 32.557 71.5387 39.2091V41.3762C77.5369 41.3762 82.395 46.2385 82.395 52.2325C82.395 58.2308 77.5327 63.0889 71.5387 63.0889H49.8219L47.6548 65.2853V78.3087L49.8219 80.4758H71.5387C83.9879 80.5722 95.0328 72.5033 98.7298 60.6158C102.418 48.7241 97.8915 35.8139 87.5801 28.839Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0756 80.3542H49.7925V62.9715H28.0756C26.5289 62.9715 24.999 62.6404 23.5906 61.9948L20.5391 62.938L11.7869 71.6314L11.024 74.6829C15.9325 78.3884 21.9223 80.3794 28.0756 80.3542Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0756 23.9599C16.0121 24.0312 5.32759 31.7564 1.47966 43.187C-2.36827 54.6176 1.46708 67.2344 11.0282 74.5865L23.6241 61.9907C18.1582 59.5218 15.7312 53.0918 18.2001 47.6259C20.669 42.16 27.099 39.7331 32.5649 42.2019C34.9709 43.2918 36.899 45.2199 37.9889 47.6259L50.5848 35.0301C45.2237 28.0258 36.8949 23.9306 28.0756 23.9599Z",
    fill: "#FBBC05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_13089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 80.4753,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.b0be21cb13ed84af4a050c50275851c3.svg";
export { ForwardRef as ReactComponent };